export default [
  {
    path: "/invest", //首页
    meta: {
      title: "充值"
    },
    component: () => import("@/views/invest/index")
  },
  {
    path: "/invest-history", //首页
    meta: {
      title: "交易记录"
    },
    component: () => import("@/views/invest-history/index")
  },
  {
    path: "/refund", //首页
    meta: {
      title: "退款申请"
    },
    component: () => import("@/views/refund/index")
  },
  {
    path: "/openError", //首页
    meta: {
      title: "开通错题"
    },
    component: () => import("@/views/openError/index")
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/invest.js